import { Carousel } from '@df/ui-carousel/carousel.interface';

// inject those styles into the carousel component
// <carousel [injectStyles]="injectStyles">
export const PRODUCT_LAYOUT_MEDIA_INJECT_STYLES: Carousel.Options['injectStyles'] = [
    `
    :host-context(.size-l),
    :host-context(.size-x) {
        .swiper-pagination-bullet {
            transform: scale(0.625);
        }

        .swiper-pagination-bullet.swiper-pagination-bullet-active {
            transform: scale(1) !important;
        }

        .swiper-pagination-bullet-active-prev,
        .swiper-pagination-bullet-active-next {
            transform: scale(0.875) !important;
        }

        .swiper-pagination-bullet-active-prev-prev,
        .swiper-pagination-bullet-active-next-next {
            transform: scale(0.75) !important;
        }
    }
`
];
